import classNames from "classnames";
import NavbarClassic from "@components/layout/Navbar/NavbarClassic";
import WarningRibbon from "@components/layout/WarningRibbon";
import CartModal from "@components/views/Cart/CartModal";
import PromoBannerContainer from "@components/layout/PromoBannerContainer";
import SalesRibbon from "./SalesRibbon";

const Header = ({ noStickyHeader, context }) => (
  <>
    <header className={classNames(!noStickyHeader && "sticky-top")}>
      <NavbarClassic context={context} />
      <SalesRibbon context={context} />
      <CartModal />
    </header>
    <WarningRibbon />
    <PromoBannerContainer />
  </>
);

export default Header;
